/* FAUST — theme behaviour. No libraries, no build step. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- product gallery: thumbnails swap the main image ---- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var cap = root.querySelector('[data-gallery-cap]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (!full) return;
        main.src = full;
        main.alt = btn.getAttribute('data-alt') || '';
        /* which exit this photograph shows. Hidden rather than left empty on
           a photo with no label, so the layout does not keep a blank line. */
        if (cap) {
          var label = btn.getAttribute('data-label') || '';
          cap.textContent = label;
          cap.hidden = label === '';
        }
        /* the frame takes its shape from the image, so the reserved box has
           to move with it. Without this the page holds the previous photo's
           height until the new one decodes and then jumps. */
        var w = btn.getAttribute('data-w'), h = btn.getAttribute('data-h');
        if (w && h) { main.width = w; main.height = h; }
        thumbs.forEach(function (o) {
          var on = o === btn;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-current', on ? 'true' : 'false');
        });
      });
    });
  }

  /* ---- terminal decode: spec values scramble into place as they enter view ---- */
  function initDecode(scope) {
    var els = (scope || document).querySelectorAll('[data-decode]:not([data-decoded])');
    if (!els.length) return;
    var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var STEPS = 10, INTERVAL = 45;

    function run(el) {
      el.setAttribute('data-decoded', '');
      var final = el.textContent;
      var len = final.length;
      var i = 0;
      var timer = setInterval(function () {
        i++;
        var revealCount = Math.round((i / STEPS) * len);
        var out = '';
        for (var j = 0; j < len; j++) {
          var ch = final.charAt(j);
          out += (j < revealCount || ch === ' ') ? ch : CHARS.charAt(Math.floor(Math.random() * CHARS.length));
        }
        el.textContent = out;
        if (i >= STEPS) { clearInterval(timer); el.textContent = final; }
      }, INTERVAL);
    }

    if (reduce || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- header: transparent over the hero, solid once scrolled ---- */
  function initHeader() {
    var hdr = document.querySelector('[data-header]');
    if (!hdr) return;
    var alwaysSolid = hdr.hasAttribute('data-always-solid');
    function update() {
      var past = window.scrollY > 60;
      hdr.classList.toggle('solid', alwaysSolid || past);
      /* Separate from 'solid' on purpose. Inner pages force solid from the
         top, so hanging the wordmark-to-mark swap off it would mean the
         wordmark only ever appeared on the home hero. This tracks the
         scroll itself, so every page opens on the wordmark. */
      hdr.classList.toggle('scrolled', past);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---- full screen menu ---- */
  function initMenu() {
    var hdr = document.querySelector('[data-header]');
    var btn = document.querySelector('[data-menu-btn]');
    var panel = document.querySelector('[data-menu-panel]');
    if (!btn || !panel) return;

    var scrim = document.querySelector('[data-menu-scrim]');

    function set(open) {
      panel.classList.toggle('show', open);
      if (hdr) hdr.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (scrim) {
        /* Unhide, force a reflow, then add the class, so the fade has a start
           value to run from. The reflow does the job requestAnimationFrame used
           to: rAF is throttled to nothing in a hidden or backgrounded tab, and
           the scrim would then sit unhidden at opacity 0 with pointer events
           live, an invisible sheet over the whole page eating every click. */
        if (open) { scrim.hidden = false; void scrim.offsetWidth; scrim.classList.add('show'); }
        else { scrim.classList.remove('show'); setTimeout(function () { scrim.hidden = true; }, 360); }
      }
      if (!open) {
        /* collapse the submenus so the drawer opens in a known state */
        panel.querySelectorAll('[data-menu-sub]').forEach(function (s) { s.classList.remove('open'); });
        panel.querySelectorAll('[data-menu-exp]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
    }

    btn.addEventListener('click', function () {
      set(!panel.classList.contains('show'));
    });
    if (scrim) scrim.addEventListener('click', function () { set(false); });

    /* the expander is a separate control from the link beside it, so a
       parent stays reachable while its children can still be opened */
    panel.querySelectorAll('[data-menu-exp]').forEach(function (exp) {
      exp.addEventListener('click', function () {
        var sub = document.getElementById(exp.getAttribute('aria-controls'));
        if (!sub) return;
        var willOpen = !sub.classList.contains('open');
        sub.classList.toggle('open', willOpen);
        exp.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { set(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('show')) { set(false); btn.focus(); return; }
      if (e.key !== 'Tab' || !panel.classList.contains('show')) return;
      /* keep tabbing inside the drawer while it is open, otherwise focus
         walks off into the page behind it with nothing visible to follow */
      var f = [btn].concat([].slice.call(
        panel.querySelectorAll('a[href],button:not([disabled])')
      )).filter(function (el) { return el.offsetParent !== null || el === btn; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---- hero video pause / play ---- */
  function initHeroVideo(root) {
    var video = root.querySelector('video');
    var btn = root.querySelector('[data-video-toggle]');
    var icon = root.querySelector('[data-video-icon]');
    if (!video || !btn || !icon) return;

    var PAUSE = '<rect x="2" y="1.5" width="3.4" height="11"></rect>' +
                '<rect x="8.6" y="1.5" width="3.4" height="11"></rect>';
    var PLAY = '<path d="M3 1.5 12.5 7 3 12.5Z"></path>';

    function show(paused) {
      icon.innerHTML = paused ? PLAY : PAUSE;
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); show(false); }
      else { video.pause(); show(true); }
    });
    if (reduce) { video.pause(); show(true); }
  }

  /* ---- hero headline rotator ---- */
  /* The headline in the markup is phrase one and is never thrown away until
     this runs, so no-JS and crawlers keep a real h1. Everything after it comes
     from the hidden list the section renders. */
  function initHeroRotator(root) {
    var h1 = root.querySelector('[data-hero-heading]');
    if (!h1) return;
    /* optional: absent when the section is set to a single fixed headline */
    var src = root.querySelector('[data-hero-rot]');

    var first = [];
    Array.prototype.forEach.call(h1.querySelectorAll('.hero-line'), function (l) {
      var t = l.textContent.trim();
      if (t) first.push(t);
    });
    if (!first.length) return;

    var phrases = [first];
    if (src) {
      Array.prototype.forEach.call(src.querySelectorAll('i'), function (el) {
        var rows = el.textContent.split('/').map(function (s) { return s.trim(); })
                     .filter(function (s) { return s.length; });
        if (rows.length) phrases.push(rows);
      });
    }
    /* the visitor asked for stillness: leave the scroll-reveal entrance alone */
    if (reduce) return;

    /* IN must match the .hero-rot .w transition duration in faust.css */
    var IN = 1200, OUT = 420, STEP = 200;
    var every = (parseFloat(h1.getAttribute('data-hero-every')) || 5) * 1000;

    /* the scroll-reveal fade would fight the word stagger, and the stagger is
       the nicer entrance, so hand the h1 over completely */
    h1.classList.remove('rv', 'in');
    h1.classList.add('hero-rot');

    function paint(idx) {
      h1.innerHTML = '';
      var n = 0;
      phrases[idx].forEach(function (line) {
        var row = document.createElement('span');
        row.className = 'hero-line';
        var words = line.split(/\s+/);
        words.forEach(function (word, w) {
          var s = document.createElement('span');
          s.className = 'w';
          s.textContent = word;
          s.style.transitionDelay = (n * STEP) + 'ms';
          row.appendChild(s);
          if (w < words.length - 1) row.appendChild(document.createTextNode(' '));
          n++;
        });
        h1.appendChild(row);
      });
      return n;
    }

    var at = 0;
    function show(idx) {
      var words = paint(idx);
      h1.classList.remove('is-out');
      void h1.offsetWidth;                 /* commit opacity 0 before animating up */
      h1.classList.add('is-in');

      /* a single headline still gets the staggered entrance, it just stays */
      if (phrases.length < 2) return;

      /* never start fading out before the last word has finished arriving */
      var settled = IN + words * STEP;
      setTimeout(function () {
        if (!document.body.contains(h1)) return;   /* section was swapped out */
        h1.classList.remove('is-in');
        h1.classList.add('is-out');
        setTimeout(function () {
          if (!document.body.contains(h1)) return;
          at = (at + 1) % phrases.length;
          show(at);
        }, OUT);
      }, Math.max(every, settled + 600));
    }
    show(0);
  }

  /* ---- question fields: reveal the free-text box when "Other" is chosen ---- */
  function initQuestionField(field) {
    var otherRadio = field.querySelector('[data-q-other]');
    var otherText = field.querySelector('[data-q-other-text]');
    if (!otherRadio || !otherText) return;
    function sync() {
      var on = otherRadio.checked;
      otherText.hidden = !on;
      if (on && !otherText.value) otherText.focus();
    }
    field.addEventListener('change', function (e) {
      if (e.target.type === 'radio') sync();
    });
    sync();
  }

  /* reads one question's answer, whatever shape it takes */
  function questionValue(field) {
    var textOnly = field.querySelector('[data-q-text]:not([data-q-other-text])');
    if (textOnly) return { value: textOnly.value.trim(), other: '' };
    var checked = field.querySelector('input[type="radio"]:checked');
    if (!checked) return { value: '', other: '' };
    var other = '';
    if (checked.hasAttribute('data-q-other')) {
      var box = field.querySelector('[data-q-other-text]');
      other = box ? box.value.trim() : '';
    }
    return { value: checked.value, other: other };
  }

  /* ---- configurator: collects the answers, hands them to the next page by query string ---- */
  function initConfigurator(root) {
    var cta = root.querySelector('[data-cfg-cta]');
    var fields = root.querySelectorAll('[data-q-field]');
    if (!cta || !fields.length) return;
    var ctaText = cta.textContent.trim();
    var readyText = cta.getAttribute('data-cfg-ready-label') || ctaText;
    var base = cta.getAttribute('data-cfg-base') || cta.getAttribute('href') || '#';

    function sync() {
      var parts = [];
      var allAnswered = true;

      Array.prototype.forEach.call(fields, function (field) {
        var key = field.getAttribute('data-q-key');
        var got = questionValue(field);
        var shown = got.other || got.value;

        var summary = root.querySelector('[data-cfg-summary="' + key + '"]');
        if (summary) summary.textContent = shown || '—';

        if (got.value) {
          parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(got.value));
          if (got.other) parts.push(encodeURIComponent(key + '__other') + '=' + encodeURIComponent(got.other));
        } else {
          allAnswered = false;
        }
      });

      if (parts.length && base !== '#') {
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        cta.setAttribute('href', base + sep + parts.join('&'));
      } else {
        cta.setAttribute('href', base);
      }
      cta.textContent = allAnswered ? readyText : ctaText;
    }

    root.addEventListener('change', sync);
    root.addEventListener('input', sync);
    sync();
  }

  /* ---- quote page: pick up whatever the configurator sent over ---- */
  function initQuotePrefill(form) {
    if (!window.URLSearchParams) return;
    var params = new URLSearchParams(window.location.search);
    if (!params.toString()) return;

    form.querySelectorAll('[data-q-field]').forEach(function (field) {
      var key = field.getAttribute('data-q-key');
      var value = params.get(key);
      if (!value) return;

      var textOnly = field.querySelector('[data-q-text]:not([data-q-other-text])');
      if (textOnly) { textOnly.value = value; return; }

      var radios = field.querySelectorAll('input[type="radio"]');
      Array.prototype.forEach.call(radios, function (r) {
        if (r.value === value) r.checked = true;
      });

      var other = params.get(key + '__other');
      var box = field.querySelector('[data-q-other-text]');
      if (other && box) {
        box.value = other;
        box.hidden = false;
      }
    });
  }

  /* ---- product page: pick up whatever the configurator sent over ---- */
  function initConfigHandoff(form) {
    if (!window.URLSearchParams) return;
    var params = new URLSearchParams(window.location.search);
    var carried = [
      { key: 'trans', label: 'Transmission', value: params.get('trans') },
      { key: 'throttle', label: 'Throttle', value: params.get('throttle') }
    ].filter(function (c) { return c.value; });
    var notes = params.get('notes');
    if (!carried.length && !notes) return;

    /* if real variants exist, try to select the one matching the choices */
    var select = form.querySelector('#variant-select');
    var matched = false;
    if (select && carried.length) {
      Array.prototype.forEach.call(select.options, function (opt) {
        if (matched) return;
        var hit = carried.every(function (c) { return opt.textContent.indexOf(c.value) > -1; });
        if (hit) { select.value = opt.value; matched = true; }
      });
    }

    /* no matching variant — attach the choices to the order so they still reach the bench */
    if (!matched) {
      carried.forEach(function (c) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + c.label + ']';
        input.value = c.value;
        form.appendChild(input);
      });
    }

    var notesEl = form.querySelector('#build-notes');
    if (notesEl && notes) notesEl.value = notes;

    var banner = document.querySelector('[data-config-carried]');
    if (banner) {
      banner.textContent = carried.map(function (c) { return c.label + ': ' + c.value; }).join('  ·  ');
      banner.hidden = false;
    }
  }

  /* ---- FAQ accordion ---- */
  function initFaq(root) {
    var list = root.querySelector('[data-faq-list]');
    if (!list) return;
    var multiple = list.getAttribute('data-allow-multiple') === 'true';

    function set(item, open) {
      item.classList.toggle('open', open);
      var b = item.querySelector('.faq-btn');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq-btn');
      if (!btn || !list.contains(btn)) return;
      var item = btn.closest('.faq-item');
      var willOpen = !item.classList.contains('open');
      if (willOpen && !multiple) {
        list.querySelectorAll('.faq-item.open').forEach(function (o) {
          if (o !== item) set(o, false);
        });
      }
      set(item, willOpen);
    });
  }

  /* ---- photo accordion ---- */
  function initPhotoAccordion(root) {
    var items = root.querySelectorAll('.acc-item');
    if (!items.length) return;
    items.forEach(function (item) {
      /* the panel is no longer the button: it holds one, stretched across it,
         so a Shop link can sit on top without being nested inside a button.
         Falls back to the panel itself if the toggle is ever absent. */
      var toggle = item.querySelector('.acc-toggle') || item;
      toggle.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-active');
        items.forEach(function (o) {
          var open = o === item && willOpen;
          o.classList.toggle('is-active', open);
          (o.querySelector('.acc-toggle') || o).setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* ---- scroll-scrubbed photo reveal ---- */
  function initScrollReveal(root) {
    var stages = Array.prototype.slice.call(root.querySelectorAll('.scrub-stage'));
    if (!stages.length) return;
    if (reduce || window.innerWidth <= 760) {
      stages.forEach(function (s) { s.style.opacity = 1; });
      return;
    }
    var ticking = false;
    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      var progress = scrollable > 0 ? Math.min(1, Math.max(0, -rect.top / scrollable)) : 0;
      var n = stages.length;
      var pos = progress * (n - 1);
      var idx = Math.min(n - 2, Math.floor(pos));
      var frac = pos - idx;
      stages.forEach(function (s, i) {
        var o = 0;
        if (n === 1) { o = 1; }
        else if (i === idx) { o = 1 - frac; }
        else if (i === idx + 1) { o = frac; }
        s.style.opacity = o;
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ---- scroll reveal (with stagger for grouped items) ---- */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.rv:not(.in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    items.forEach(function (el) {
      var group = el.closest('[data-rv-stagger]');
      if (!group) return;
      var siblings = group.querySelectorAll('.rv');
      var idx = Array.prototype.indexOf.call(siblings, el);
      el.style.transitionDelay = (Math.min(idx, 8) * 70) + 'ms';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('in');
        io.unobserve(el);
        /* drop the stagger delay once revealed, or it also delays hover and click transitions */
        var d = parseFloat(el.style.transitionDelay) || 0;
        setTimeout(function () { el.style.transitionDelay = ''; }, d + 1000);
      });
    }, { threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Variant picker.

     The form shows one select per option rather than one listing every
     combination, so the selected values have to be matched back to a variant
     id before the form submits. Options are compared by index against
     variant.options, which Liquid gives us in the same order. */
  function initVariantPicker(form) {
    var data = form.querySelector('[data-variant-data]');
    var idField = form.querySelector('[data-variant-id]');
    /* An option is a dropdown or a row of buttons depending on how long its
       values are, decided in Liquid. Both are wrapped in the same small
       interface so the rest of this function never has to care which it got,
       and a product can mix the two. */
    var controls = [];
    form.querySelectorAll('.opt-group').forEach(function (group) {
      var sel = group.querySelector('.opt-select');
      if (sel) {
        controls.push({
          get: function () { return sel.value; },
          set: function (v) { sel.value = v; },
          has: function (v) {
            return Array.prototype.some.call(sel.options, function (o) { return o.value === v; });
          },
          on: function (fn) { sel.addEventListener('change', fn); }
        });
        return;
      }
      var radios = Array.prototype.slice.call(group.querySelectorAll('.opt-radio'));
      if (!radios.length) return;   /* the build-notes group, which is neither */
      controls.push({
        get: function () {
          for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return radios[i].value; }
          return '';
        },
        set: function (v) { radios.forEach(function (r) { r.checked = r.value === v; }); },
        has: function (v) { return radios.some(function (r) { return r.value === v; }); },
        on: function (fn) { radios.forEach(function (r) { r.addEventListener('change', fn); }); }
      });
    });
    if (!data || !idField || !controls.length) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    /* the gallery is a sibling of the form, not a child, so option changes
       have to look wider than the form to reach it */
    var scope = form.closest('.shopify-section') || document;
    var firstApply = true;
    /* Set while the option is being changed by a thumbnail click, so apply()
       knows not to move the gallery back. Without it, clicking the second
       photo of an exit would set the option, and the option would then drag
       the gallery to that exit's first photo, throwing away the click. */
    var fromThumb = false;
    var button = form.querySelector('.add-btn');
    var priceBox = form.closest('.pdp-info');
    priceBox = priceBox ? priceBox.querySelector('.pdp-price') : null;
    var addLabel = button ? button.textContent.trim() : '';

    function apply() {
      var initial = firstApply;
      firstApply = false;
      var chosen = controls.map(function (c) { return c.get(); });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.length !== chosen.length) continue;
        var same = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { same = false; break; }
        }
        if (same) { match = v; break; }
      }

      /* a combination that does not exist is possible once a product has
         variants removed, so fail closed rather than posting a stale id */
      if (!match) {
        idField.value = '';
        if (button) { button.disabled = true; button.textContent = addLabel; }
        return;
      }

      idField.value = match.id;

      /* Point the gallery at the option just chosen, so picking "Straight"
         shows the straight one rather than leaving the customer to work out
         which of nine photos is theirs.

         This clicks the matching thumbnail rather than setting the main
         image directly. The thumbnail handler already keeps the alt text,
         the active state and the reserved width and height in step, and the
         frame takes its shape from the image, so writing src here as well
         would be a second place that has to remember all of that. */
      /* Not on the first pass, though, unless the URL named a variant. The
         page opens on the product's own featured image, which is the shot of
         all three exits together, and that is the right thing to land on
         before anyone has chosen. Syncing on load would flash it away to the
         default variant for no reason. A ?variant= link is someone arriving
         having already chosen, so that one does sync. */
      if (match.media_id && !fromThumb && (!initial || /[?&]variant=/.test(location.search))) {
        var thumb = scope.querySelector('[data-gallery-thumb][data-media-id="' + match.media_id + '"]');
        if (thumb && !thumb.classList.contains('is-active')) thumb.click();
      }

      if (priceBox && match.price) priceBox.textContent = match.price;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? addLabel : (button.dataset.soldOut || addLabel);
      }
    }

    controls.forEach(function (c) { c.on(apply); });

    /* Browsing the photographs selects the option too, so what is on screen
       and what goes in the cart cannot disagree. Someone who clicks the
       straight backshell and presses Add should not be sent a right angle
       one because the dropdown never moved.

       The photo's own label is the link: it is already on the thumbnail for
       the caption, and it is written to match the option value exactly. A
       photo whose label matches no option, the shot of all three together,
       leaves the dropdown alone rather than guessing. */
    scope.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var label = thumb.getAttribute('data-label');
        if (!label) return;
        var target = null;
        controls.forEach(function (c) { if (c.has(label)) target = c; });
        if (!target || target.get() === label) return;
        target.set(label);
        fromThumb = true;
        apply();
        fromThumb = false;
      });
    });

    apply();
  }

  /* ---- boot ---- */
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hero]').forEach(initHeroVideo);
    scope.querySelectorAll('[data-hero]').forEach(initHeroRotator);
    scope.querySelectorAll('[data-configurator]').forEach(initConfigurator);
    scope.querySelectorAll('[data-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-photo-accordion]').forEach(initPhotoAccordion);
    scope.querySelectorAll('[data-gallery]').forEach(initGallery);
    scope.querySelectorAll('#product-form').forEach(initConfigHandoff);
    scope.querySelectorAll('#product-form').forEach(initVariantPicker);
    scope.querySelectorAll('[data-q-field]').forEach(initQuestionField);
    scope.querySelectorAll('#quote-form').forEach(initQuotePrefill);
    scope.querySelectorAll('[data-scroll-reveal]').forEach(initScrollReveal);
    initReveal(scope);
    initDecode(scope);
  }

  /* ---- cart drawer ---- */
  function initCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var btn = document.querySelector('[data-cart-btn]');
    if (!drawer || !btn || !window.fetch) return;

    var scrim = document.querySelector('[data-cart-scrim]');
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var countEl = drawer.querySelector('[data-cart-count]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var ship = drawer.querySelector('[data-cart-ship]');
    var shipText = ship && ship.querySelector('[data-cart-ship-text]');
    var shipFill = ship && ship.querySelector('[data-cart-ship-fill]');
    var threshold = parseInt(drawer.getAttribute('data-free-threshold') || '0', 10);
    var strings = JSON.parse(drawer.getAttribute('data-strings') || '{}');
    /* pairings for the product on this page, empty everywhere else */
    var pairs = JSON.parse(drawer.getAttribute('data-pairs') || '[]');
    /* the free gift, and the variants that earn it. Null when the offer is
       off or has no qualifying products, which is the state that keeps a
       half-configured offer from advertising itself. */
    var gift = null;
    try { gift = JSON.parse(drawer.getAttribute('data-gift') || 'null'); } catch (e) { gift = null; }
    /* The gift product can have several variants, and the customer has chosen
       none of them: the line is added for them as soon as a trigger lands in
       the cart. So every test below asks "is this any gift variant" rather
       than "is this the default one", and the line itself carries a chooser.
       Liquid omits 'variants' only on an older cached render, hence the
       fallback to the single id. */
    var giftVariants = (gift && gift.variants && gift.variants.length)
      ? gift.variants
      : (gift && gift.id ? [{ id: gift.id, title: '', image: gift.image }] : []);
    function isGiftVariant(id) {
      return giftVariants.some(function (v) { return v.id === id; });
    }
    var lastFocus = null;

    /* Shopify hands back cents and a format string like "${{amount}}". Doing
       the substitution here keeps the drawer correct if the shop currency
       changes, rather than hard-coding a dollar sign. */
    function money(cents) {
      var fmt = drawer.getAttribute('data-money-format') || '${{amount}}';
      function commas(s) {
        var p = String(s).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return p.join('.');
      }
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        var v = cents / 100;
        if (name === 'amount_no_decimals') return commas(Math.round(v));
        if (name === 'amount_with_comma_separator') return commas(v.toFixed(2)).replace(/[.,]/g, function (c) { return c === '.' ? ',' : '.'; });
        if (name === 'amount_no_decimals_with_comma_separator') return commas(Math.round(v)).replace(/,/g, '.');
        return commas(v.toFixed(2));
      });
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function sized(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }

    /* Placeholders arrive as %TITLE%, %COUNT%, %AMOUNT% rather than Liquid's
       own {{ }}. Liquid cannot parse a nested {{ }} inside a filter argument,
       so the interpolation has to survive the trip out as a plain token. */
    function t(key, sub) {
      var s = strings[key] || '';
      if (sub) Object.keys(sub).forEach(function (k) {
        s = s.split('%' + k.toUpperCase() + '%').join(sub[k]);
      });
      return s;
    }

    function render(cart) {
      var n = cart.item_count;
      countEl.textContent = n ? '(' + (n === 1 ? t('one', { count: n }) : t('other', { count: n })) + ')' : '';

      /* the header badge is server-rendered on load; keep it truthful after
         every change without a page reload */
      var badge = btn.querySelector('.cart-count');
      if (n > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.setAttribute('aria-hidden', 'true');
          btn.appendChild(badge);
        }
        badge.textContent = n;
      } else if (badge) {
        badge.remove();
      }
      btn.setAttribute('aria-label', t('cart') + (n ? ', ' + (n === 1 ? t('one', { count: n }) : t('other', { count: n })) : ''));

      if (!n) {
        body.innerHTML = '<div class="cart-empty"><p>' + esc(t('empty')) +
          '</p><a class="btn btn-ghost" href="' + esc(t('shop_url')) + '">' + esc(t('continue')) + '</a></div>';
        /* write the total before hiding the footer, so the number in the DOM
           is never a leftover from the cart that was just emptied */
        subEl.textContent = money(cart.total_price);
        foot.hidden = true;
        if (ship) ship.hidden = true;
        return;
      }

      body.innerHTML = cart.items.map(function (it) {
        var opt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        /* line item properties carry the build notes field; an unread note is a
           rebuild, so it belongs in front of the customer here too */
        var props = '';
        if (it.properties) {
          Object.keys(it.properties).forEach(function (k) {
            if (k.charAt(0) !== '_' && it.properties[k]) {
              props += '<p class="cart-line-opt">' + esc(k) + ': ' + esc(it.properties[k]) + '</p>';
            }
          });
        }
        /* The free line carries a chooser whenever the gift product has more
           than one variant. Without it the customer is handed whichever
           variant Liquid resolved first and has no way to say they wanted the
           other exit. The plain variant title is dropped when the chooser is
           present, because the select already says which one it is. */
        var giftPick = '';
        if (it.properties && it.properties._gift && giftVariants.length > 1) {
          giftPick =
            '<label class="cart-gift-pick">' +
              '<span class="visually-hidden">' + esc(t('gift_pick', { title: it.product_title })) + '</span>' +
              '<select data-gift-swap>' +
                giftVariants.map(function (v) {
                  return '<option value="' + esc(v.id) + '"' +
                    (v.id === it.variant_id ? ' selected' : '') + '>' + esc(v.title) + '</option>';
                }).join('') +
              '</select>' +
            '</label>';
        }
        return '' +
          '<div class="cart-line" data-key="' + esc(it.key) + '">' +
            '<a class="cart-thumb" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
              (it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" width="160" height="160" loading="lazy">' : '') +
            '</a>' +
            /* Four grid children, not three with the stepper nested inside the
               title block. The stepper has to be placed independently because
               a narrow drawer stacks title, price and stepper in one column
               while a wide one puts the price off to the right, and a nested
               element cannot be moved between those two arrangements. */
            '<div class="cart-line-main">' +
              '<a class="cart-line-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
              (opt && !giftPick ? '<p class="cart-line-opt">' + esc(opt) + '</p>' : '') + props + giftPick +
            '</div>' +
            /* A discounted line shows what it was as well as what it is. The
               gift lands here at zero, and a bare $0.00 with nothing beside it
               reads as a pricing fault rather than as the offer working. */
            '<span class="cart-line-price">' +
              (it.original_line_price > it.final_line_price
                ? '<s>' + money(it.original_line_price) + '</s> <em>' +
                    (it.final_line_price === 0 ? esc(t('gift_free')) : money(it.final_line_price)) + '</em>'
                : money(it.final_line_price)) +
            '</span>' +
            '<div class="cart-qty">' +
              '<button type="button" data-cart-step="-1" aria-label="' + esc(t('decrease', { title: it.product_title })) + '">&minus;</button>' +
              '<output aria-live="off">' + it.quantity + '</output>' +
              '<button type="button" data-cart-step="1" aria-label="' + esc(t('increase', { title: it.product_title })) + '">+</button>' +
              '<button type="button" class="cart-remove" data-cart-remove aria-label="' + esc(t('remove_named', { title: it.product_title })) + '">' + esc(t('remove')) + '</button>' +
            '</div>' +
          '</div>';
      }).join('');

      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.variant_id] = true; });

      /* The free gift, shown only once something in the cart has actually
         earned it, and only while it is not already in there. Shopify's
         automatic discount is what zeroes the price at checkout; this row
         just makes sure nobody misses that it is on offer. */
      var giftInCart = cart.items.some(function (it) { return isGiftVariant(it.variant_id); });
      if (gift && gift.id && !giftInCart) {
        var earned = gift.triggers && gift.triggers.some(function (id) { return inCart[id]; });
        if (earned) {
          body.insertAdjacentHTML('beforeend',
            '<div class="cart-pairs cart-gift"><span class="mono">' + esc(t('gift_heading')) + '</span><ul><li>' +
              '<a class="pair-thumb" href="' + esc(gift.url) + '" tabindex="-1" aria-hidden="true">' +
                (gift.image ? '<img src="' + esc(gift.image) + '" alt="" width="160" height="160" loading="lazy">' : '') +
              '</a>' +
              '<div>' +
                '<a class="pair-title" href="' + esc(gift.url) + '">' + esc(gift.title) + '</a>' +
                '<span class="pair-price"><s>' + esc(gift.was) + '</s> <em>' + esc(t('gift_free')) + '</em></span>' +
              '</div>' +
              '<button type="button" class="pair-add" data-cart-pair-add="' + esc(gift.id) + '" ' +
                'aria-label="' + esc(t('pair_add_named', { title: gift.title })) + '">' + esc(t('gift_added')) + '</button>' +
            '</li></ul></div>');
        }
      }

      /* Companion parts for what was just added. Anything already in the cart
         is dropped, so the row never offers something sitting three lines
         above it. These are fitment pairings, not a popularity guess: a
         StormX needs both looms whether or not anyone has bought one yet. */
      var offer = pairs.filter(function (p) {
        /* the gift has its own row above; without this it lists twice on any
           product that also names it as a companion part */
        if (isGiftVariant(p.id)) return false;
        if (inCart[p.id]) return false;
        /* Liquid built this list from the cart as it stood when the page
           loaded. Remove that item without reloading and its companions would
           otherwise linger, recommending a part for something no longer being
           bought. Each entry carries the variants it hangs off, so a pairing
           lives exactly as long as the thing that justifies it. */
        if (p['for'] && p['for'].length) {
          return p['for'].some(function (id) { return inCart[id]; });
        }
        return true;
      });
      if (offer.length) {
        body.insertAdjacentHTML('beforeend',
          '<div class="cart-pairs"><span class="mono">' + esc(t('pair_heading')) + '</span><ul>' +
          offer.map(function (p) {
            return '<li>' +
              '<a class="pair-thumb" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
                (p.image ? '<img src="' + esc(p.image) + '" alt="" width="160" height="160" loading="lazy">' : '') +
              '</a>' +
              '<div>' +
                '<a class="pair-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
                /* the source product's note, where adding the pair is worth
                   something. Carries no figures, so a reprice cannot strand a
                   stale number here. */
                (p.note ? '<span class="pair-note">' + esc(p.note) + '</span>' : '') +
                '<span class="pair-price">' + esc(p.price) + '</span>' +
              '</div>' +
              '<button type="button" class="pair-add" data-cart-pair-add="' + esc(p.id) + '" ' +
                'aria-label="' + esc(t('pair_add_named', { title: p.title })) + '">' + esc(t('pair_add')) + '</button>' +
            '</li>';
          }).join('') + '</ul></div>');
      }

      subEl.textContent = money(cart.total_price);
      foot.hidden = false;

      if (ship && threshold > 0) {
        var left = threshold - cart.total_price;
        ship.hidden = false;
        ship.classList.toggle('is-met', left <= 0);
        shipText.textContent = left > 0
          ? t('free_shipping_away', { amount: money(left) })
          : t('free_shipping_met');
        shipFill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
      }
    }

    function getCart() {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
      }).then(function (r) { return r.json(); });
    }

    function post(url, payload) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); });
    }

    /* The gift is put in the cart for the customer, and taken out again if
       the thing that earned it leaves. Asking someone to click Add to receive
       something free is a question with one answer, and every question is a
       step where an order can be lost.

       Two rules keep this from being pushy or wrong:

       - it only ever adds on the back of a real add to cart, never on a plain
         refresh. Remove the free line and it stays removed; it comes back
         when another qualifying unit is added, not the instant the drawer
         reopens. An item that cannot be deleted reads as a bug.
       - only a line this code added carries _gift, and only such a line is
         ever removed. A backshell the customer chose and paid for is left
         alone, whatever else happens in the cart.

       Shopify's automatic discount is still what zeroes the price. This only
       decides what sits in the cart. */
    var giftBusy = false;
    function syncGift(cart, allowAdd) {
      if (!gift || !gift.id || giftBusy) return Promise.resolve(cart);
      var inCart = {}, has = false, autoLine = null;
      cart.items.forEach(function (it) {
        inCart[it.variant_id] = true;
        if (isGiftVariant(it.variant_id)) {
          has = true;
          if (it.properties && it.properties._gift) autoLine = it;
        }
      });
      var earned = gift.triggers && gift.triggers.some(function (id) { return inCart[id]; });

      /* already holding one, bought or given: adding a second would ship two
         and charge for one */
      if (allowAdd && earned && !has) {
        giftBusy = true;
        return post('/cart/add.js', { id: gift.id, quantity: 1, properties: { _gift: 'true' } })
          .then(getCart)
          .catch(getCart)
          .then(function (c) { giftBusy = false; return c; });
      }
      if (!earned && autoLine) {
        giftBusy = true;
        return post('/cart/change.js', { id: autoLine.key, quantity: 0 })
          .catch(getCart)
          .then(function (c) { giftBusy = false; return c; });
      }
      return Promise.resolve(cart);
    }

    function refresh(allowAdd) {
      return getCart()
        .then(function (cart) { return syncGift(cart, allowAdd === true); })
        .then(render);
    }

    function set(open) {
      drawer.classList.toggle('show', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (scrim) {
        if (open) { scrim.hidden = false; void scrim.offsetWidth; scrim.classList.add('show'); }
        else { scrim.classList.remove('show'); setTimeout(function () { scrim.hidden = true; }, 360); }
      }
      if (open) {
        lastFocus = document.activeElement;
        var close = drawer.querySelector('[data-cart-close]');
        if (close) close.focus();
      } else if (lastFocus) {
        lastFocus.focus();
        lastFocus = null;
      }
    }

    function change(key, qty) {
      drawer.classList.add('is-busy');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        /* no add here: taking the last Nexus R3 out has to take the free
           backshell with it, but nothing a customer removes should come back */
        .then(function (cart) { return syncGift(cart, false); })
        .then(render)
        .catch(function () { return refresh(); })
        .then(function () { drawer.classList.remove('is-busy'); });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      set(true);
      refresh();
    });
    /* All of them, not just the first. There are two ways out of the drawer
       now: the X in the header and "Keep shopping" under the checkout button.
       querySelector would have wired only the X and left the other one looking
       like a control and behaving like text. The focus target on open is still
       deliberately the first one, which is the X. */
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function () { set(false); });
    });
    if (scrim) scrim.addEventListener('click', function () { set(false); });

    body.addEventListener('click', function (e) {
      var padd = e.target.closest('[data-cart-pair-add]');
      if (padd) {
        padd.disabled = true;
        drawer.classList.add('is-busy');
        /* The gift row's own button. It only appears if the customer removed
           the free line, so this is them asking for it back, and the line has
           to be tagged the same way the automatic one is. Untagged, it would
           survive the Nexus R3 being removed and quietly become a $49.99
           backshell nobody chose to buy. */
        var addId = Number(padd.getAttribute('data-cart-pair-add'));
        var addProps = isGiftVariant(addId) ? { _gift: 'true' } : undefined;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: addId, quantity: 1, properties: addProps })
        }).then(function () { return refresh(true); })
          .catch(function () { return refresh(true); })
          .then(function () { drawer.classList.remove('is-busy'); });
        return;
      }
      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var step = e.target.closest('[data-cart-step]');
      if (step) {
        var out = line.querySelector('output');
        var next = Math.max(0, parseInt(out.textContent, 10) + parseInt(step.getAttribute('data-cart-step'), 10));
        change(key, next);
        return;
      }
      if (e.target.closest('[data-cart-remove]')) change(key, 0);
    });

    /* Swapping which variant of the gift is in the cart. Remove then add,
       because /cart/change.js can change a line's quantity but cannot move it
       to a different variant.

       Two things this has to get right:

       - the new line is tagged _gift again. Untagged, it would survive the
         Nexus R3 being removed and quietly become a backshell at full price
         that nobody chose to buy, which is the same trap the add button has.
       - if the add half fails after the remove succeeded, the customer is
         left without their free item, so the recovery refresh is allowed to
         re-add rather than just redraw. */
    body.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-gift-swap]');
      if (!sel) return;
      var swapLine = sel.closest('.cart-line');
      if (!swapLine) return;
      var swapKey = swapLine.getAttribute('data-key');
      var nextId = Number(sel.value);
      sel.disabled = true;
      drawer.classList.add('is-busy');
      post('/cart/change.js', { id: swapKey, quantity: 0 })
        .then(function () {
          return post('/cart/add.js', { id: nextId, quantity: 1, properties: { _gift: 'true' } });
        })
        .then(function () { return refresh(); })
        .catch(function () { return refresh(true); })
        .then(function () { drawer.classList.remove('is-busy'); });
    });

    /* add to cart without leaving the page. The form keeps its real action, so
       a failed script still posts and lands on the cart page as before. */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' },
        credentials: 'same-origin', body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        set(true);
        return refresh(true);
      }).catch(function () {
        /* let the browser do what it would have done without us */
        form.submit();
      }).then(function () {
        if (submit) submit.disabled = false;
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('show')) return;
      if (e.key === 'Escape') { set(false); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(drawer.querySelectorAll('a[href],button:not([disabled])'))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---- scroll ruler ----
     A column of ticks down the right edge with the one at your position
     marked, like the scale on an instrument rather than a scrollbar.

     Built to cost nothing on scroll. The ticks are written once and never
     touched again; scrolling only moves a single marker, with transform so
     it stays on the compositor and never triggers layout. The scroll
     listener is passive and throttled through requestAnimationFrame, the
     same pattern the rest of this file uses, so fast scrolling still does
     at most one calculation per frame. */
  function initRuler() {
    if (reduce) return;
    if (document.querySelector('.ruler')) return;
    /* The width cutoff lives in CSS, not here. Testing it once at load meant a
       window that started narrow and was widened never got a ruler at all. */

    /* Spaced by justify-content, so the count sets the density rather than
       the length. 46 over 560px holds roughly the 12px pitch the shorter rail
       had.

       46 and not 45 because the long graduation is every 5n+1: 1, 6, 11 and
       so on. At 45 the last long tick is 41 and the scale trails off on four
       short ones. At 46 it lands on the final tick, so the rail is bounded
       top and bottom the way a real scale is. Keep any future count at
       5n + 1. */
    var TICKS = 46;
    var el = document.createElement('div');
    el.className = 'ruler';
    el.setAttribute('aria-hidden', 'true');
    var marks = '';
    for (var i = 0; i < TICKS; i++) marks += '<i></i>';
    el.innerHTML = marks + '<span class="ruler-now"></span>';
    document.body.appendChild(el);

    var now = el.querySelector('.ruler-now');
    var ticking = false, travel = 0;

    function measure() {
      travel = el.clientHeight - now.offsetHeight;
    }
    function update() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      /* a page shorter than the window has nothing to indicate */
      if (max <= 0) { el.classList.remove('on'); return; }
      el.classList.add('on');
      /* Measured here rather than once at startup. The rail is display:none
         until 'on' lands a line above, and a hidden element reports a height
         of nothing, so measuring first gave the marker nowhere to travel and
         it sat still through every scroll. Re-reads only while the figure is
         useless, so the usual path stays free of layout reads. */
      if (travel <= 0) measure();
      var p = Math.min(1, Math.max(0, window.scrollY / max));
      now.style.transform = 'translateY(' + (p * travel) + 'px)';
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMenu();
    initCart();
    initRuler();
    boot(document);
  });

  /* theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initMenu();
    initCart();
    boot(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.faq-item') : null;
    if (item) {
      item.classList.add('open');
      var b = item.querySelector('.faq-btn');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
  });
})();
